import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { PipesModule } from 'shared/pipes/pipes.module';
import { SegmentsNavigationModule } from 'shared/segments-navigation/segments-navigation.module';
import { LoaderModule } from 'shared/loader/loader.module';
import { RightPanelModule } from 'shared/right-panel/right-panel.module';
import { NavModule } from 'shared/nav/nav.module';
import { AccountModule } from 'shared/account/account.module';
import { FormModule } from 'shared/form/form.module';
import { DropdownModule } from 'shared/dropdown/dropdown.module';
import { IconModule } from 'shared/icon/icon.module';
import { OnlyIntegerNumberModule } from 'shared/only-integer-number/only-integer-number.module';
import { AppTooltipModule } from 'shared/tooltip/tooltip.module';

import { DetailsPageHeaderComponent } from './details-page-header/details-page-header.component';
import { DetailsPageModalComponent } from './details-page-modal/details-page-modal.component';
import { ViewEditButtonComponent } from './view-edit-button/view-edit-button.component';
import { DetailsControlComponent } from './details-control/details-control.component';
import { LettersCounterComponent } from './letters-counter/letters-counter.component';
import {ButtonModule} from 'shared/button/button.module';
import {HintsModule} from 'shared/hints/hints.module';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        SegmentsNavigationModule,
        LoaderModule,
        RightPanelModule,
        NavModule,
        AccountModule,
        FormModule,
        DropdownModule,
        IconModule,
        OnlyIntegerNumberModule,
        AppTooltipModule,
        TypeaheadModule.forRoot(),
        NgxMaskDirective,
        NgxMaskPipe,
        ButtonModule,
        HintsModule,
    ],
  declarations: [
    DetailsPageHeaderComponent,
    DetailsPageModalComponent,
    ViewEditButtonComponent,
    DetailsControlComponent,
    LettersCounterComponent,
  ],
  exports: [
    DetailsPageHeaderComponent,
    DetailsPageModalComponent,
    ViewEditButtonComponent,
    DetailsControlComponent,
    LettersCounterComponent,
  ],
  providers: [provideNgxMask()],
})
export class DetailsPageModule {}
